module.exports = __webpack_public_path__ + "media/images/dublicate-2feec6300f84bd849cddb4532b846ef9.png";